import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import AdmissionFormComp from "./AdmissionFormComp";

const NewUserAdmissionForm = () => {
  const isAuthenticated = useSelector(
    (state) => state.RS_Authentication.isAuthenticated
  );
  return (
    <div>
      {!isAuthenticated ? (
        <div
          className="login-wrapper overflow-auto"
          style={{
            minHeight: "100vh",
            height: "match-content",
          }}
        >
         <AdmissionFormComp/>
        </div>
      ) : (
        <Navigate to="/" />
      )}
    </div>
  );
};

export default NewUserAdmissionForm;
